module.exports = __webpack_public_path__ + "img/slider-easyer.2d86e64f.png";